module.exports = __webpack_public_path__ + "static/media/promo2.caac78a5.jpg";